
/*
  Easyforms DateInput encapsulation class.
  [public methods]
    setEnabled(enabled): enable or disable all inputs of the DateInput.
    isEnabled(): determine if at least one of the composite inputs are enabled
    setYMD(year, month, day): set the fields to the specifed values
    getDate(): get a javascript Date or null if the inputs are invalid

*/
import {SuperSelect} from "./super-select";
import {CA_stringTrim} from "../../common/strings";

export function chooseDate(formReference, dateInputName) {
    //only proceed if the date input is enabled
    const dateInput = new DateInput(formReference, dateInputName);
    const { datePicker } = GlobalEnt;

    if (dateInput.isEnabled() && datePicker) {
        const date = dateInput.getDate();
        if (date != null)
            datePicker.setDate(date);

        datePicker.onOk(function() {
            const date = datePicker.getDate();
            chooseDateCallback(date.getFullYear(), date.getMonth() + 1, date.getDate(), dateInputName, formReference);
        });

        datePicker.show();
    }
}

export function chooseDateCallback(year, month, day, dateInputName, formReference) {
    const dateInput = new DateInput(formReference, dateInputName);
    dateInput.setYMD(year, month, day);

    //the user changed the value of the date - make sure any onchange subscribers know it
    dateInput.fireOnChange();
}

export class DateInput {
    constructor(formReference, dateInputName) {
        this.frm = formReference;
        this.name = dateInputName;

        this.day = this.frm.querySelector('select[name="' + this.name + '_selDay"]');
        this.month = this.frm.querySelector('select[name="' + this.name + '_selMonth"]');
        this.year = this.frm.querySelector('input[name="' + this.name + '_txtYear"]');
    }

    setEnabled(enabled) {
        this.day.disabled = !enabled;
        this.month.disabled = !enabled;
        const elm = document.getElementById(this.name);
        if (elm) {
            elm.classList.value = (!enabled) ? "calIconAnchor disabled" : "calIconAnchor";
        }
    };

    isEnabled() {
        return (this.day && !this.day.disabled)
            || (this.month && !this.month.disabled)
            || (this.year && !this.year.disabled);
    };

    setYMD(year, month, day) {
        let selDay = new SuperSelect(this.day);
        let dayOpt = selDay.getOption(day);

        let selMonth = new SuperSelect(this.month);
        let monthOpt = selMonth.getOption(month);

        if (dayOpt != null && monthOpt != null) {
            selDay.clearSelections();
            dayOpt.setSelected(true);

            selMonth.clearSelections();
            monthOpt.setSelected(true);

            this.year.value = year;
            return true;
        } else
            return false;
    };

    getDate() {
        //get year string
        let yearStr = this.year.value;

        //get month string
        let monthStr = "";
        let opt = new SuperSelect(this.month).getSelectedOption();
        if (opt != null)
            monthStr = opt.getValue();

        //get day string
        let dayStr = "";
        opt = new SuperSelect(this.day).getSelectedOption();
        if (opt != null)
            dayStr = opt.getValue();

        //parse integer values
        let year = parseInt(CA_stringTrim(yearStr), 10);
        let month = parseInt(CA_stringTrim(monthStr), 10);
        let day = parseInt(CA_stringTrim(dayStr), 10);

        //all valid integers?
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
            //valid ranges?
            if (month > 0 && month < 13
                && day > 0 && day < 32
                && year > 0 && year < 3000) {
                return new Date(year, month - 1, day);
            }
        }

        return null;
    };

    // Run event listeners of the element for the 'change' event.
    fireOnChange() {
        if (this.day)
            this.day.dispatchEvent(new Event('change'));
        if (this.month)
            this.month.dispatchEvent(new Event('change'));
        if (this.year)
            this.year.dispatchEvent(new Event('change'));
    }
}